<script>
import toggleModal from '@/mixins/toggleModal';
import { mapActions } from 'vuex';

export default {
  mixins: [toggleModal],
  methods: {
    ...mapActions({
      addGiftCardAction: 'products/addGiftCard',
    }),
    handleOk(values) {
      this.addGiftCardAction({
        ...values,
      });
      this.hideModal();
    },
  },
};
</script>

<template>
  <div>
    <a-modal :open="show" :footer="null" @cancel="hideModal" >
      <FormKit
        type="form"
        submit-label="Add gift card"
        @submit="handleOk"
      >
        <h1 class="text-2xl font-bold mb-2">Create new gift card</h1>
        <FormKit
          type="text"
          name="displayName"
          label="Display name"
          placeholder="Display name"
          validation="required"
        />
        <FormKit
          type="text"
          name="sku"
          label="Sku"
          placeholder="Sku"
          validation="required"
        />
        <FormKit
          type="number"
          number="integer"
          name="price"
          label="Price"
          placeholder="Enter price"
          validation="required"
        />
      </FormKit>
    </a-modal>
  </div>
</template>

<style scoped lang="scss">

</style>
